<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-alert :value="!placingOfferAllowed && dataLoaded" type="warning" color="lightred">Konkurs poza terminem naboru ofert.
		</v-alert>

		<v-alert :value="!legalFormMembership && dataLoaded" type="warning">Twoja organizacja nie jest uprawniona do
			udziału w konkursie. Dozwolone formy prawne: {{Object.values(this.contestTerms.legalForms).join(", ")}}.
		</v-alert>

		<offers-list
			:offers="myOffers"
			:contest-id="contestData.id"
			:placing-offer-allowed="placingOfferAllowed"
			:legal-form-membership="legalFormMembership"
			:editing-visible="true"
			:show-privillages-icon="true"
			:bidder-name-visible="false"
			:header="contestName"
			:is-paginated="true"
			@offer-removed="removeOffer"
			@showDialogWithUsers="showDialogWithUsers"
			empty-warning="W tym konkursie nie ma jeszcze Twoich ofert">

			<template v-slot:extraAction="slotData">
				<v-list-tile-action
					v-if="(slotData.offer.offerStatus === 'AWAITING_MAIN_BIDDER_ACCEPTANCE'
						|| slotData.offer.offerStatus === 'POST_CORRECTION_MAIN')
						&& slotData.offer.acceptAllowed"
				>
					<egranty-icon-button
						icon="send"
						color="blue"
						label="Zatwierdź"
						for="my-contest-offer-list-view-confirm"
						id="my-contest-offer-list-view-confirm"
						@click="acceptSubbidderOffer(slotData.offer)"/>
				</v-list-tile-action>
				<v-list-tile-action
					v-if="(slotData.offer.offerStatus === 'AWAITING_MAIN_BIDDER_ACCEPTANCE'
						|| slotData.offer.offerStatus === 'POST_CORRECTION_MAIN')
						&& slotData.offer.acceptAllowed"
				>
					<egranty-icon-button
						icon="close"
						color="blue"
						label="Odrzuć"
						for="my-contest-offer-list-view-reject"
						id="my-contest-offer-list-view-reject"
						@click="rejectSubbidderOffer(slotData.offer)"/>
				</v-list-tile-action>
				<v-list-tile-action
					v-if="slotData.offer.bidderPreviewEnabled"
				>
					<egranty-icon-button icon="content_paste_search" color="primary"
						label="Zobacz opinię końcową"
						@click="previewFinalEvaluation(slotData.offer)"
					></egranty-icon-button>
				</v-list-tile-action>
			</template>

		</offers-list>
		<mutual-offers-list
			:offers="mutualOffers"
			:contest-id="contestData.id"
			:placing-offer-allowed="placingOfferAllowed"
			@refresh="refreshMutualOffers()"
		/>
		<egranty-error-list-popup
			title="Nie udało się wysłać oferty:"
			:error-list="sendOfferErrors.messages"
			:is-open="sendOfferErrors.showPopup"
			@close="sendOfferErrors.showPopup = false"
		/>
		<egranty-autocomplete
			class="no-print"
			style="background-color: primary"
			:is-visible.sync="dialogUserPrivillages.show"
			:headers="dialogUserPrivillages.headers"
			:possibilities="dialogUserPrivillages.users"
			title="Przekaż prawa do edycji oferty"
			hint=""
			search-field-label="Wybierz użytkownika"
			:description="(x) => x.name"
			@cancel="dialogUserPrivillages.show = false"
			@save="givePrivillagesToAnotherUser"
		></egranty-autocomplete>
	</div>
</template>

<script>
	import MutualOffersList from "./components/MutualOffersList";
	import {OfferAcceptance} from "@/api/generated/OfferAcceptance";
	import OffersList from "./components/OffersList";
	import {Offer} from "@/api/generated/Offer";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {Dates} from "@/utils/Dates";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import EgrantyAutocomplete from "../../../genericComponents/EgrantyAutocomplete";


	export default {
		name: "MyContestOfferListView",

		components: {EgrantyErrorListPopup, OffersList, MutualOffersList, EgrantyIconButton, EgrantyAutocomplete},

		data() {
			return {
				dialogUserPrivillages: {
					show: false,
					headers: {
						name: "nazwa",
					},
					users: [],
					offerId: null,
				},
				contestData: {
					id: this.$route.params.id,
				},
				contestTerms: {
					contestStartDateTime: "",
					contestEndDateTime: "",
					legalForms: [],
				},
				offersLoaded: false,
				correctionCausesLoaded: false,
				mutualOffersLoaded: false,
				mutualOffersCorrectionCausesLoaded: false,
				causesMatched: false,
				mutualCausesMatched: false,
				termsLoaded: false,
				membershipStatusLoaded: false,
				mutualOffers: [],
				contestName: "",
				myOffers: null,
				legalFormMembership: false,
				correctionCauses: [],
				mutualOffersCorrectionCauses: [],
				sendOfferErrors: {
					showPopup: false,
					messages: [],
				},
			};
		},

		computed: {
			placingOfferAllowed() {
				return this.isInPast(this.contestTerms.contestStartDateTime)
					&& this.isInFuture(this.contestTerms.contestEndDateTime);
			},
			dataLoaded() {
				return this.termsLoaded && this.membershipStatusLoaded;
			},

		},

		methods: {
			showDialogWithUsers(offer){
				this.dialogUserPrivillages.show = true;
				this.dialogUserPrivillages.users = offer.listOfUsersToGivePrivillages;
				this.dialogUserPrivillages.offerId = offer.id;
			},
			givePrivillagesToAnotherUser(user){
				Offer.postGivePrivillages(this, this.dialogUserPrivillages.offerId,user.id, () => {
					loadMyOffers(this);
					this.dialogUserPrivillages.show = false;
					this.dialogUserPrivillages.users = [];
					this.dialogUserPrivillages.offerId = null;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się nadać uprawnień", errorResponse);
				});
			},
			refreshMutualOffers() {
				loadMutualOffers(this);
			},

			acceptSubbidderOffer(offer) {
				Offer.postAcceptSubbidderOffer(this, offer.id, () => {
					loadMyOffers(this);
				}, errorResponse => {
          this.sendOfferErrors.messages = errorResponse.message.split("\n");
          if (this.sendOfferErrors.messages && this.sendOfferErrors.messages[0] === "OFFER_LIMIT_EXCEEDED") {
            this.sendOfferErrors.messages.shift();
            let errors = this.sendOfferErrors.messages.map(message => message.concat(": przekroczono limit ofert."));
            if (errors.length) {
              this.sendOfferErrors.messages = errors;
              this.sendOfferErrors.showPopup = true;
            }
            this.$messagesBus.$emit("error", "Przekroczono limit ofert w tym konkursie", errorResponse);
          } else {
            this.sendOfferErrors.messages.pop();
            if (this.sendOfferErrors.messages.length) {
              this.sendOfferErrors.showPopup = true;
            }
            this.$messagesBus.$emit("error", "Nie udało się zaakceptować oferty", errorResponse);
          }
				});
			},

			rejectSubbidderOffer (offer) {
				Offer.postRejectSubbidderOffer(this, offer.id, () => {
					loadMyOffers(this);
					this.$messagesBus.$emit("success", "Oferta odrzucona pomyślnie");
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się odrzucić oferty.", errorResponse);
				});
			},

			removeOffer (offerId) {
				this.myOffers.splice(this.myOffers.findIndex(offer => offer.id === offerId), 1);
			},

			previewFinalEvaluation(offer) {
				Offer.getFinalEvaluationId(this, offer.id, response => {
					this.$router.push("final-evaluation-peek/" + response);
				});
			},

			matchCauses () {
				this.correctionCauses.forEach(item => {
					let offer = this.myOffers.find(o => o.id === item.id);
					this.$set(offer, "correctionCause", item.correctionCause);
					this.$set(offer, "correctionDeadline", item.correctionDeadline);
				});
				this.causesMatched = true;
			},

			matchMutualCauses () {
				this.mutualOffersCorrectionCauses.forEach(item => {
					let mutualOffer = this.mutualOffers.find(o => o.id === item.id);
					this.$set(mutualOffer, "correctionCause", item.correctionCause);
				});
				this.mutualCausesMatched = true;
			}
		},

		created() {
			loadMyOffers(this);
			if (this.roles.isBidder()) {
				loadMutualOffers(this);
				loadMutualOffersCorrectionCauses(this);
			}
			loadCorrectionCauses(this);
			loadContestTerms(this);
			getLegalFormMembership(this);
			loadContestName(this);
		},

		mixins: [
			Dates,
		],
	};

	function loadMutualOffers(ctx) {
		OfferAcceptance.get(ctx, ctx.contestData.id,
			successResponse => {
				ctx.mutualOffers = successResponse;
				ctx.mutualOffersLoaded = true;
				if (ctx.mutualOffersCorrectionCausesLoaded && !ctx.mutualCausesMatched) ctx.matchMutualCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować ofert współdzielonych", errorResponse);
			});
	}

	function loadMutualOffersCorrectionCauses (ctx) {
		OfferAcceptance.getCauses(ctx, ctx.contestData.id,
			successResponse => {
				ctx.mutualOffersCorrectionCauses = successResponse;
				ctx.mutualOffersCorrectionCausesLoaded = true;
				if (ctx.mutualOffersLoaded && !ctx.mutualCausesMatched) ctx.matchMutualCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
			});
	}

	function loadMyOffers(ctx) {
		Offer.getBidderOfferList(ctx, ctx.contestData.id,
			successResponse => {
				ctx.myOffers = successResponse;
				ctx.offersLoaded = true;
				if (ctx.correctionCausesLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować ofert", errorResponse);
			});
	}

	function loadCorrectionCauses (ctx) {
		Offer.getBidderOffersCorrectionCauses(ctx, ctx.contestData.id,
			successResponse => {
				ctx.correctionCauses = successResponse;
				ctx.correctionCausesLoaded = true;
				if (ctx.offersLoaded && !ctx.causesMatched) ctx.matchCauses();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować powodów do poprawek", errorResponse);
			});
	}

	function loadContestTerms(ctx) {
		PublicContest.getContestTerms(ctx, ctx.contestData.id,
			successResponse => {
				ctx.contestTerms = successResponse;
				ctx.termsLoaded = true;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować warunków konkursu", errorResponse);
			});
	}

	function loadContestName(ctx) {
		PublicContest.getPanelInfo(ctx, ctx.contestData.id,
			successResponse => {
				ctx.contestName = "Moje oferty do konkursu " + successResponse.name;
			});
	}

	function getLegalFormMembership(ctx) {
		PublicContest.getLegalFormMembership(ctx, ctx.contestData.id,
			successResponse => {
				ctx.legalFormMembership = successResponse;
				ctx.membershipStatusLoaded = true;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować uprawnień do składania oferty", errorResponse);
			});
	}
</script>

<style scoped>
</style>
